"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDropdown = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var MobileDropdown = function (_a) {
    var children = _a.children, _b = _a.csx, csx = _b === void 0 ? {} : _b, menuPosition = _a.menuPosition, isOpen = _a.isOpen;
    return (theme_ui_1.jsx(theme_ui_1.Flex, { sx: __assign(__assign({ position: "absolute", width: "100%", backgroundColor: __1.theme.colors.offBlack, boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.25)" }, menuPosition), csx) }, isOpen ? children : null));
};
exports.MobileDropdown = MobileDropdown;
